export const printReceiptRequestCode = {
    "curl": {
      "request": `curl -X 'POST' 
'https://demo-api.westpay.se/in-store/api/v1/printData'
-H 'accept: text/plain'
-H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco'
-H 'Ocp-Apim-Subscription-Key: 76591d32138f4f60b580db9ec9167f1d'
-H 'Content-Type: application/json'
-d '{
    "terminalId": "80000456",
    "htmlContent": "<html><body><h2>Test printing!</h2><span style=\"font-size:22;line-height:100%;font-family:monospace\">Test large size</span><br><span style=\"font-size:16;line-height:100%;font-family:monospace\">Test medium size</span><br><span style=\"font-size:13;line-height:100%;font-family:monospace\">Test small size</span><br></body></html>"
}'`
    },
    "java": {
      "request": `import java.io.IOException;
import java.net.URI;
import java.net.http.HttpClient;
import java.net.http.HttpHeaders;
import java.net.http.HttpRequest;
import java.net.http.HttpResponse;
import java.net.http.HttpResponse.BodyHandlers;
import java.nio.charset.StandardCharsets;

import com.google.gson.Gson;

public class ReceiptExample {
    public static void main(String[] args) {
        String url = "https://demo-api.westpay.se/in-store/api/v1/printData";
        String authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco";
        String contentType = "application/json";
        String ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";

        ReceiptRequest requestBody = new ReceiptRequest("80000456", "<html><body><h2>Test printing!</h2><span style=\"font-size:22;line-height:100%;font-family:monospace\">Test large size</span><br><span style=\"font-size:16;line-height:100%;font-family:monospace\">Test medium size</span><br><span style=\"font-size:13;line-height:100%;font-family:monospace\">Test small size</span><br></body></html>");

        Gson gson = new Gson();
        String requestBodyJson = gson.toJson(requestBody);

        HttpClient client = HttpClient.newHttpClient();

        HttpRequest request = HttpRequest.newBuilder()
                .uri(URI.create(url))
                .header("accept", "text/plain")
                .header("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey)
                .header("Authorization", authorization)
                .header("Content-Type", contentType)
                .POST(HttpRequest.BodyPublishers.ofString(requestBodyJson, StandardCharsets.UTF_8))
                .build();

        try {
            HttpResponse<String> response = client.send(request, BodyHandlers.ofString());
            int statusCode = response.statusCode();
            HttpHeaders responseHeaders = response.headers();
            String responseBody = response.body();

            System.out.println("Response Code: " + statusCode);
            System.out.println("Response Headers: " + responseHeaders);
            System.out.println("Response Body: " + responseBody);
        } catch (IOException | InterruptedException e) {
            e.printStackTrace();
        }
    }
}

class ReceiptRequest {
    private String terminalId;
    private String htmlContent;

    public ReceiptRequest(String terminalId, String htmlContent) {
        this.terminalId = terminalId;
        this.htmlContent = htmlContent;
    }

    public String getTerminalId() {
        return terminalId;
    }

    public void setTerminalId(String terminalId) {
        this.terminalId = terminalId;
    }

    public String getHtmlContent() {
        return htmlContent;
    }

    public void setHtmlContent(String htmlContent) {
        this.htmlContent = htmlContent;
    }
}`
    },
    "C#": {
      "request": `using System;
using System.Net.Http;
using System.Text;
using System.Text.Json;
using System.Threading.Tasks;

namespace ReceiptExample
{
    class Program
    {
        static async Task Main(string[] args)
        {
            string url = "https://demo-api.westpay.se/in-store/api/v1/printData";
            string authorization = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco";
            string contentType = "application/json";
            string ocpApimSubscriptionKey = "76591d32138f4f60b580db9ec9167f1d";

            ReceiptRequest requestBody = new ReceiptRequest
            {
                TerminalId = "80000456",
                HtmlContent = "<html><body><h2>Test printing!</h2><span style=\"font-size:22;line-height:100%;font-family:monospace\">Test large size</span><br><span style=\"font-size:16;line-height:100%;font-family:monospace\">Test medium size</span><br><span style=\"font-size:13;line-height:100%;font-family:monospace\">Test small size</span><br></body></html>"
            };

            HttpClient client = new HttpClient();
            client.DefaultRequestHeaders.Add("accept", "text/plain");
            client.DefaultRequestHeaders.Add("Authorization", authorization);
            client.DefaultRequestHeaders.Add("Ocp-Apim-Subscription-Key", ocpApimSubscriptionKey);
            client.DefaultRequestHeaders.Add("Content-Type", contentType);

            var requestBodyJson = JsonSerializer.Serialize(requestBody);
            var requestBodyContent = new StringContent(requestBodyJson, Encoding.UTF8, "application/json");

            HttpResponseMessage response;
            try
            {
                response = await client.PostAsync(url, requestBodyContent);
            }
            catch (Exception e)
            {
                Console.WriteLine("An error occurred: " + e.Message);
                return;
            }

            var statusCode = (int)response.StatusCode;
            var responseContent = await response.Content.ReadAsStringAsync();

            Console.WriteLine("Response Code: " + statusCode);
            Console.WriteLine("Response Body: " + responseContent);
        }
    }

    class ReceiptRequest
    {
        public string TerminalId { get; set; }
        public string HtmlContent { get; set; }
    }
}`
    },
    "python": {
      "request": `import requests
import json

url = "https://demo-api.westpay.se/in-store/api/v1/printData"
headers = {
    "accept": "text/plain",
    "Authorization": "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco",
    "Ocp-Apim-Subscription-Key": "76591d32138f4f60b580db9ec9167f1d",
    "Content-Type": "application/json"
}

data = {
    "terminalId": "80000456",
    "htmlContent": "<html><body><h2>Test printing!</h2><span style=\"font-size:22;line-height:100%;font-family:monospace\">Test large size</span><br><span style=\"font-size:16;line-height:100%;font-family:monospace\">Test medium size</span><br><span style=\"font-size:13;line-height:100%;font-family:monospace\">Test small size</span><br></body></html>"
}

try:
    response = requests.post(url, headers=headers, data=json.dumps(data))
    print("Response Code:", response.status_code)
    print("Response Body:", response.text)
except requests.exceptions.RequestException as e:
    print("An error occurred:", e)`
    },
    
    "JavaScript": {
      "request": `const axios = require('axios');

const url = 'https://demo-api.westpay.se/in-store/api/v1/printData';
const headers = {
  'accept': 'text/plain',
  'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImRlZWxha2EiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2ODMwMzU5MTUsImV4cCI6MTY4ODIxOTkxNSwiaWF0IjoxNjgzMDM1OTE1LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiZGVlbGFrYVBvc3RtYW4xIn0.lfqUjrGF_1SH1iBV_Fs57K0y4fjWQapZy349PN2_sco',
  'Ocp-Apim-Subscription-Key': '76591d32138f4f60b580db9ec9167f1d',
  'Content-Type': 'application/json'
};

const data = {
  terminalId: '80000456',
  htmlContent: '<html><body><h2>Test printing!</h2><span style=\"font-size:22;line-height:100%;font-family:monospace\">Test large size</span><br><span style=\"font-size:16;line-height:100%;font-family:monospace\">Test medium size</span><br><span style=\"font-size:13;line-height:100%;font-family:monospace\">Test small size</span><br></body></html>'
};

axios.post(url, data, { headers })
  .then(response => {
    console.log('Response Code:', response.status);
    console.log('Response Body:', response.data);
  })
  .catch(error => {
    console.error('An error occurred:', error);
  });`
    }
  };
  
export const printReceiptRequestCodeResponse = `{
  "status": 0
}`;
  